import { render, staticRenderFns } from "./custom_questions.form.vue?vue&type=template&id=52418ef6&scoped=true&"
import script from "./custom_questions.form.vue?vue&type=script&lang=js&"
export * from "./custom_questions.form.vue?vue&type=script&lang=js&"
import style0 from "./custom_questions.form.vue?vue&type=style&index=0&id=52418ef6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52418ef6",
  null
  
)

export default component.exports